// extracted by mini-css-extract-plugin
export var divider = "_na-0";
export var systemMessage = "_na-1";
export var systemMessageWrapper = "_na-2";